import { ThemeOptions } from '@mui/material/styles/createTheme';

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#fff',
    },
    secondary: {
      main: '#000',
    },
  },
  typography: {
    fontFamily: 'Helvetica Neue',
  },
};

export default themeOptions;
